import AgreementsPage from './AgreementsPage';

export default AgreementsPage;
